import styled from "@emotion/styled";
import { FluidType } from "./FluidType";

interface INavItem {
  color?: string;
  align?: string;
  width?: string;
  margin?: string | number;
  fontWeight?: string | number;
  pointer: boolean;
}

const NavItem = styled.span`
  text-align: ${(props: INavItem) => props.align || "left"};
  color: ${(props: INavItem) => props.color};
  width: ${(props: INavItem) => props.width || "auto"};
  margin: ${(props: INavItem) => props.margin || 0};
  font-weight: ${(props: INavItem) => props.fontWeight || "300"};
  ${FluidType("12px", "15px", "320px", "1200px")};
  &:hover {
    cursor: ${(props: INavItem) => (props.pointer ? "pointer" : "auto")};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export default NavItem;



// WEBPACK FOOTER //
// ./src/Components/Text/NavItem.tsx